import { useCallback, useState } from "react";
import { useToast } from "../context/ToastContext";

export function useAsyncAction() {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const run = useCallback(
    async (task, successMessage) => {
      setBusy(true);
      try {
        const result = await task();
        if (successMessage) toast.success(successMessage);
        return result;
      } catch (error) {
        toast.error(error.message);
        return null;
      } finally {
        setBusy(false);
      }
    },
    [toast]
  );

  return { busy, run };
}
